import EventBus from '../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'

class ShippingForm {
    
    /**
     * Construct module
     * @param container
    */
    constructor(container) {
        
        /**
         * Container jQuery object
         * @type {object}
        */
        this.container = container
        
        /**
         * Option radio form
         * @type {object}
        */
        this.checkForm = jQuery('#shipping-checks')
        
        /**
         * Address form
         * @type {object}
        */
        this.addressForm = jQuery('#shipping-address')
        
        /**
         * Rate button
         * @type {object}
        */
        this.rateBtn = jQuery('#shipping-rate-btn')
        
        /**
         * Prices container
         * @type {object}
        */
        this.pricesContainer = jQuery('#shipping-prices-container')
        
        /**
         * Prices table
         * @type {object}
        */
        this.pricesTable = jQuery('#shipping-prices')
        
        /**
         * Submit button
         * @type {object}
        */
        this.submitBtn = jQuery('#order-form-submit-btn')
        
        /**
         * US shipping note
         * @type {object}
        */
        this.usNote = jQuery('#us-shipping-note')
        
        this.bindEvents()
        
    }
    
    /**
     * Run module
    */
    run() {
        this.loadRates()
    }
    
    /**
     * Option radio input checked
     * @param event
    */
    optionRadioChecked(event) {
        
        this.checkForm.find('input[type="radio"]').each((i, radio) => {
            if (radio != event.target) {
                jQuery(radio).prop('checked', false)
            }
        })
        
        this.render()
        
    }
    
    /**
     * Retrieve the currently selected radio option
     * @return object
    */
    getSelectedRadio() {
        return this.checkForm.find('input[type="radio"]:checked').first()
    }
    
    /**
     * Retrieve the currently selected radio option state
     * @return string
    */
    getSelectedRadioState() {
        return this.getSelectedRadio().data('state')
    }
    
    /**
     * Render shipping form
    */
    render() {
        
        let state = this.getSelectedRadioState()

        switch (state) {
            
            case 'same-as-user':
                this.handlePrices()
                this.hideAddressForm()
            break
            
            case 'new':
                this.handlePrices()
                this.showAddressForm()
            break
            
            case 'not-required':
                this.hidePriceContainer()
                this.hideRateBtn()
                this.hideAddressForm()
                this.setCanProgress(true)
            break
            
        }
        
    }
    
    /**
     * Handle price display
    */
    handlePrices() {
        this.hidePriceContainer()
        this.setCanProgress(false)
        this.showRateBtn()
    }
    
    /**
     * Hide price container
    */
    hidePriceContainer() {
        this.pricesContainer.hide()
    }
    
    /**
     * Show price container
    */
    showPriceContainer() {
        this.pricesContainer.show()
    }
    
    /**
     * Hide rate button
    */
    hideRateBtn() {
        this.rateBtn.hide()
    }
    
    /**
     * Show rate button
    */
    showRateBtn() {
        this.rateBtn.show()
    }
    
    /**
     * Hide address form
    */
    hideAddressForm() {
        this.addressForm.hide()
    }
    
    /**
     * Show address form
    */
    showAddressForm() {
        this.addressForm.show()
    }
    
    /**
     * Set whether the form can progress
     * @param bool
    */
    setCanProgress(bool) {
        bool ? this.container.addClass('can-progress') : this.container.removeClass('can-progress')
    }
    
    /**
     * Perform rate calculation lookup
    */
    calculateRate() {
        
        //Start loading animation
        this.startLoading()
        
        //Get data for request
        let data = {
            state: this.getSelectedRadioState()
        }
        
        if (data.state == 'new') {
            jQuery.extend(data, this.addressForm.serializeJSON())
        }
        
        //Post request to server
        jQuery.post(this.rateBtn.data('url'), data, (response) => {
            this.hideRateBtn()
            this.renderPrices(response.rates, 0, response.currency, response.usa)
        }).fail((xhr) => {
            
            //Display error modal
            EventBus.publish('error', {
                xhr: xhr
            })
            
        }).always(this.stopLoading)
    }
    
    /**
     * Start loading animation
    */
    startLoading() {
        EventBus.publish('loading.start', jQuery('body'))
    }
    
    /**
     * Stop loading animation
    */
    stopLoading() {
        EventBus.publish('loading.stop', jQuery('body'))
    }
    
    /**
     * Render prices
     * @param rates
     * @param selected
     * @param currency
     * @param usa
    */
    renderPrices(rates, selected, currency, usa) {
        
        let
            active,
            label,
            paid = this.pricesContainer.data('paid')
            
        //Attempt to retrieve currency from container if parameter is empty
        if (!currency) {
            currency = this.pricesContainer.data('currency')
        }
        
        //Set default selected index
        if (!selected) {
            selected = 0
        }
        
        //Initialise HTML
        var html = ''
        
        //Loop through rates and construct HTML
        jQuery.each(rates, (i, rate) => {
            
            active = selected > 0 ? (rate.id === selected) : (i === 0)
            label = (rate.delivery_label ? rate.delivery_label : (rate.delivery_date ? ((new Date(rate.delivery_date)).toLocaleDateString('en-us', {weekday: "long", month: "long", day: "numeric"})) : null))

            html += `
                <tr class="cursor-pointer ${active ? 'active' : ''}">
                    <td>
                        ${rate.name}
                        ${label ? ('<br /><small>' + label + '</small>') : ''}
                    </td>
                    <td>${currency}${rate.cost}</td>
                    <td>
                        <div class="custom-control custom-radio">
                            <input class="custom-control-input" ${paid ? 'disabled' : ''} id="shipping_rate_${rate.id}" ${active ? 'checked="checked"' : ''} name="shipping_rate_id" type="radio" value="${rate.id}">
                            <label for="shipping_rate_${rate.id}" class="custom-control-label">&nbsp;</label>
                        </div>
                    </td>
                </tr>
            `
            
            
        })
        
        //Apply HTML to prices table
        this.pricesTable.html(html)
        
        //Show prices container
        this.showPriceContainer()
        
        //Toggle US shipping note
        if (usa) {
            this.usNote.show();
        }
        else {
            this.usNote.hide();
        }
        
        //Show submit button
        this.setCanProgress(true)
        
    }
    
    /**
     * Load rates
    */
    loadRates() {
        
        //Load JSON string from data attribute
        if (typeof shippingRates != 'object' || shippingRates.length === 0) {
            return
        }
        
        //Render prices
        this.renderPrices(shippingRates, shippingRate, '', this.pricesContainer.data('usa'))
        
    }
    
    /**
     * Force price select
     * @param event
    */
    forcePriceSelect(event) {
        
        //Cancel if clicked element was radio input
        if (jQuery(event.target).is('input')) {
            return
        }
        
        //Get input
        let input = jQuery(event.currentTarget).find('input')
        
        //Cancel if input is disabled
        if (input.prop('disabled')) {
            return
        }
        
        //Force selection on related input
        input.prop('checked', true).trigger('change')
        
    }
    
    /**
     * Price radio input checked
     * @param event
    */
    priceRadioChecked(event) {
        jQuery(event.target).closest('tr').addClass('active').siblings().removeClass('active')
    }
    
    /**
     * Complete form
    */
    completeForm() {
        
        //Start loading animation
        this.startLoading()
        
        //Get selected shipping price element
        let selected = this.pricesTable.find('input:checked')
        
        //Initialise data object to send to server
        let data;
        
        //Populate data to send to server
        if (this.getSelectedRadioState() == 'not-required') {
            
            //Data for when shipping is not required
            data = {
                not_required: true
            }
            
        }
        else {
            
            //Populate data for when shipping is required
            data = {
                rate_id: selected.length > 0 ? selected.attr('value') : null
            }
            
        }
        
        //Post request to server
        jQuery.post(this.container.data('url'), data, (response) => {
            window.location = response.redirect
        }).fail((xhr) => {
            
            //Stop loading animation
            this.stopLoading()
            
            //Display error modal
            EventBus.publish('error', {
                xhr: xhr
            })
            
        })
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Option radio check
        this.checkForm.on('change', 'input[type="radio"]', this.optionRadioChecked.bind(this))
        
        //Price radio check
        this.pricesTable.on('change', 'input', this.priceRadioChecked.bind(this))
        
        //Rate calculation button click
        this.rateBtn.click(this.calculateRate.bind(this))
        
        //Prices table select
        this.pricesTable.on('click', 'tr', this.forcePriceSelect.bind(this))
        
        //Submit button click
        this.submitBtn.click(this.completeForm.bind(this))
        
        //Run modules
        EventBus.subscribe('run-modules', this.run.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let container = jQuery('#shipping-container')
    
    if (container.length > 0) {
        new ShippingForm(container)
    }
    
})

export default ShippingForm